import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { defaultMST7020_R01Dto, MST7020_R01Dto } from "./Dto_MST7020_R01";

export interface MST7020_R01Filter {
	dateRange: DateRange | undefined;
}

export interface Store_MST7020_R01 {

    
	MST7020_R01Filter: MST7020_R01Filter;
	MST7020_R01PastFilter: MST7020_R01Filter;
	setMST7020_R01Filter: (filter: Partial<MST7020_R01Filter>) => void;
	setMST7020_R01PastFilter: (filter: Partial<MST7020_R01Filter>) => void;

    MST7020_R01List: MST7020_R01Dto[];
    setMST7020_R01List: (list: MST7020_R01Dto[]) => void;

    selectedMST7020_R01: MST7020_R01Dto | undefined;
    setSelectedMST7020_R01: (bank: MST7020_R01Dto | undefined) => void;
	initSelectedMST7020_R01: () => void;

    editMST7020_R01: MST7020_R01Dto | null;
    setEditMST7020_R01: (data: MST7020_R01Dto | null) => void;
    updateEditMST7020_R01: (key: keyof MST7020_R01Dto, value: any) => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;						setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultMST7020_R01Filter: MST7020_R01Filter = {

	dateRange: { 
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
}

export const sendTypeMap_MST7020_R01 = [
	{ title: '장문', value: 'long', length: 2000 },
	{ title: '단문', value: 'short', length: 100 }
]

//send_msg 테이블의 senderStatus
export const senderStatusMap_MST7020_R01 = [
	{ title: '접수', value: '0' },
	{ title: '대기중', value: '1' },
	{ title: '처리중', value: '2' },
	{ title: '발송완료', value: '3' },
	{ title: '취소완료', value: '4' },
	{ title: '실패', value: 'failed' },
]

export const useMST7020_R01Store = create<Store_MST7020_R01>((set) => ({
    
    MST7020_R01Filter: defaultMST7020_R01Filter,
	MST7020_R01PastFilter: defaultMST7020_R01Filter,
    setMST7020_R01Filter: (cond) => set((state) => ({ MST7020_R01Filter: { ...state.MST7020_R01Filter, ...cond } })),
    setMST7020_R01PastFilter: (cond) => set((state) => ({ MST7020_R01PastFilter: { ...state.MST7020_R01PastFilter, ...cond } })),


    MST7020_R01List: [],
    setMST7020_R01List: (list) => set({ MST7020_R01List: list }),

    selectedMST7020_R01: defaultMST7020_R01Dto,
    setSelectedMST7020_R01: (bank) => set((state) => {
		let editMST7020_R01 = defaultMST7020_R01Dto;
		if (bank) {
			editMST7020_R01 = {
				...bank,
			}
		}
		return { ...state, selectedMST7020_R01: bank, editMST7020_R01: editMST7020_R01 };
    }),
	initSelectedMST7020_R01: () => set({ selectedMST7020_R01: undefined, editMST7020_R01: null }),

    editMST7020_R01: defaultMST7020_R01Dto,
    setEditMST7020_R01: (data) => set((state) => {
		// console.log(data);
		let editMST7020_R01 = defaultMST7020_R01Dto;
		if (data) {
			editMST7020_R01 = {
				...data
			}
		}
		return { ...state, editMST7020_R01: editMST7020_R01 };
    }),
    updateEditMST7020_R01: (key, value) => set((state) => ({
        editMST7020_R01: state.editMST7020_R01 ? { ...state.editMST7020_R01, [key]: value } : null
    })),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	initData: () => set({
		MST7020_R01Filter: defaultMST7020_R01Filter,
		MST7020_R01PastFilter: defaultMST7020_R01Filter,
		MST7020_R01List: [],
		selectedMST7020_R01: undefined,
		editMST7020_R01: defaultMST7020_R01Dto,
		allCount: 0,
		scrollTop: null,
	}),

    
}));